var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExclamationIconOrange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9908 1.83337C5.93075 1.83337 1.83325 5.94004 1.83325 11C1.83325 16.06 5.93075 20.1667 10.9908 20.1667C16.0599 20.1667 20.1666 16.06 20.1666 11C20.1666 5.94004 16.0599 1.83337 10.9908 1.83337ZM11.9166 6.41671H10.0833V11.9167H11.9166V6.41671ZM11.9166 13.75H10.0833V15.5834H11.9166V13.75ZM3.66659 11C3.66659 15.0517 6.94825 18.3334 10.9999 18.3334C15.0516 18.3334 18.3333 15.0517 18.3333 11C18.3333 6.94837 15.0516 3.66671 10.9999 3.66671C6.94825 3.66671 3.66659 6.94837 3.66659 11Z",
    fill: "#F09A37"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationIconOrange);
export default __webpack_public_path__ + "static/media/exclamation-icon-orange.82f4b21e9a82c46ddc675ea7b4e5dacb.svg";
export { ForwardRef as ReactComponent };